// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Theme from "../../styles/Theme.bs.js";
import * as Emotion from "../../bindings/Emotion.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

function Divider$Divider(props) {
  let __className = props.className;
  let label = props.label;
  let className = __className !== undefined ? __className : "";
  let baseStyles = Emotion.Css.css({
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    margin: "2rem 0"
  });
  let lineStyles = Emotion.Css.css({
    flex: "1",
    height: "1px",
    backgroundColor: Emotion.Utils.Color.border
  });
  let labelStyles = Emotion.Css.css({
    fontFamily: Theme.Theme.Typography.fontFamily.sans,
    fontSize: "0.6875rem",
    fontWeight: "500",
    letterSpacing: "0.15em",
    textTransform: "uppercase",
    color: Emotion.Utils.Color.textSecondary
  });
  let dividerClassName = Emotion.Css.cx([
    baseStyles,
    className
  ]);
  if (label !== undefined) {
    return JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("div", {
          className: lineStyles
        }),
        JsxRuntime.jsx("span", {
          children: label,
          className: labelStyles
        }),
        JsxRuntime.jsx("div", {
          className: lineStyles
        })
      ],
      className: dividerClassName
    });
  } else {
    return JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx("div", {
        className: lineStyles
      }),
      className: dividerClassName
    });
  }
}

let Divider = {
  make: Divider$Divider
};

export {
  Divider,
}
/* Theme Not a pure module */
